export default __webpack_public_path__ + "create-new-clip.png";